import { useEffect, useState } from "react";
import { FileUp, UsersRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminStudentsManagerV2({ studentsCount, upgradeEnquiries, onNotice, onChanged }) {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [displayCount, setDisplayCount] = useState(studentsCount);

  useEffect(() => setDisplayCount(studentsCount), [studentsCount]);

  const upload = async (event) => {
    event.preventDefault();
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const response = await fetch(`${API}/admin/students/import-csv`, { method: "POST", credentials: "include", body: form });
      const body = await response.json();
      if (!response.ok) throw new Error(body.detail || "Could not import CSV");
      setResult(body);
      setDisplayCount((count) => count + body.imported);
      await onChanged();
      onNotice("Student CSV import complete.");
    } catch (error) {
      onNotice(error.message);
    } finally {
      setUploading(false);
    }
  };

  return <section className="admin-panel" data-testid="admin-students-manager"><div className="admin-panel-heading"><div><h2>Student Recruitment Data</h2><p>Import up to 5000 student profiles. Existing Phone or Email matches are updated.</p></div><span className="student-count-chip"><UsersRound size={17} /> {displayCount} students</span></div><form className="csv-upload-form" onSubmit={upload} data-testid="student-csv-upload-form"><label>Student CSV file<input required type="file" accept=".csv,text/csv" onChange={(event) => setFile(event.target.files?.[0] || null)} data-testid="student-csv-file-input" /></label><p>Required columns: Name, Trade, Education, District, Experience, Phone, Email, Address.</p><button className="primary-button" disabled={!file || uploading} data-testid="student-csv-upload-button"><FileUp size={17} /> {uploading ? "Importing…" : "Import student CSV"}</button></form>{result && <div className="import-result" data-testid="student-import-result"><strong>Import complete</strong><span>{result.imported} added · {result.updated} updated · {result.skipped} skipped</span>{result.errors.map((error) => <small key={error}>{error}</small>)}</div>}<div className="upgrade-enquiry-list"><h3>Upgrade enquiries</h3>{upgradeEnquiries.length ? upgradeEnquiries.map((enquiry) => <article key={enquiry.id}><strong>{enquiry.company_name}</strong><span>{enquiry.message || "No message provided"}</span><small>{enquiry.created_at}</small></article>) : <p>No upgrade enquiries yet.</p>}</div></section>;
}